import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MenuItem } from 'primeng/api';

import { HisNavigationMenuService } from '../../service/base/his-navigation-menu.service';
import { HisSessionStorageKeys } from '../../model/his-session-storage-keys';
import { HisSessionStorageService } from '../../service/base/his-session-storage.service';

@Component({
    selector: 'his-breadcrumb',
    templateUrl: './his-breadcrumb.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HisBreadcrumbComponent implements OnInit {
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    private navService = inject(HisNavigationMenuService);
    private sessionStorageService = inject(HisSessionStorageService);


    private rootItem: MenuItem;

    items: MenuItem[] = new Array<MenuItem>();

    ngOnInit() {
        let navigation = this.navService.getFlatNavigation();
        this.rootItem = navigation.link_homepage ? navigation.link_homepage.item : null;

        this.setItems(); // required for navigation bypassing the router (first call, redirects etc.)
        this.router.events.subscribe( (routerEvent: any) => {
            // type Event or RouterEvent would not compile, see https://github.com/angular/angular/issues/43124

            // https://angular.io/api/router/Event: There are 15 router events permitting to track the router lifecycle.
            // We only want to pick one; the best choice is NavigationEnd, because then all initializations are complete.
            if (routerEvent instanceof NavigationEnd) {
                this.setItems();
            }
        });
    }

    private setItems() {
        console.log('HisBreadcrumbComponent setItems()');
        // first priority: an explicit navigationPosition.
        // Its value may be the whole path of menu item names or just the leaf element.
        let navigationPositionUrlParam = this.route.snapshot.queryParams.navigationPosition;
        if (navigationPositionUrlParam) {
            let navigationItemNames: string[] = navigationPositionUrlParam.split(',').map((elem: string) => elem.trim()).filter(Boolean);
            if (navigationItemNames.length > 0) {
                let lastItemName = navigationItemNames[navigationItemNames.length - 1];
                console.log('breadcrumb: lastItemName =', lastItemName);
                let menuItem = this.navService.getMenuItem(lastItemName);
                console.log('breadcrumb: explicit menuItem =', menuItem);
                if (menuItem) {
                    this.setBreadcrumbFromMenuItem(menuItem);
                    console.log('HisBreadcrumbComponent menuItem: ', menuItem);

                    return;
                }
            }
        }

        // second priority: items that have a menu entry
        let activeMenuItem = this.navService.getActiveMenuItem();
        console.log('breadcrumb: activeMenuItem =', activeMenuItem);
        if (activeMenuItem) {
            this.setBreadcrumbFromMenuItem(activeMenuItem);
            return;
        }

        // The active page does not have a navigation menu entry (e.g. search results)
        // and possible items got lost because of a redirect -> derive the breadcrumb from the last menu item.
        // This creates the entries in the right language after language changes, too. #214545
        let lastMenuItem = this.sessionStorageService.get(HisSessionStorageKeys.CS_SYS_LAST_MENU_ITEM) as MenuItem;
        if (lastMenuItem) {
            this.setBreadcrumbFromMenuItem(lastMenuItem);
        }
    }

    private setBreadcrumbFromMenuItem(menuItem: MenuItem) {
        this.items = [];
        let parents = this.navService.getParentsOfMenuItem(menuItem);
        if (parents.filter(item => item.id === 'link_homepage').length === 0) {
            if (this.rootItem) {
                this.items.push(this.rootItem);
            }
        }
        this.items.push(...parents);
        this.sessionStorageService.put(HisSessionStorageKeys.CS_SYS_LAST_MENU_ITEM, menuItem);
    }

    public onItemClick(event: any) {
        console.log('Clear angular session storage keys onItemClick');
        this.sessionStorageService.clearAngularSessionStorageKeys();
    }
}
